import React from 'react'

// Create a Context
export default React.createContext()
